import { MissionData } from '../blocks/mission'
import template from './templates/RJF07.rbxl'
import thumbnail1 from './thumbnails/RJF07/RedBlock.png'
import thumbnail2 from './thumbnails/RJF07/GreenBlock.png'
import thumbnail3 from './thumbnails/RJF07/BlueBlock.png'
import thumbnail4 from './thumbnails/RJF07/YellowBlock.png'

const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  thumbnail: '',
  title: '',
  template,
  chapters: [{}, {}, {}, {}, {}],
  objects: [
    {
      name: '①あかいブロック',
      thumbnail: thumbnail1,
    },
    {
      name: '②みどりのブロック',
      thumbnail: thumbnail2,
    },
    {
      name: '③あおいブロック',
      thumbnail: thumbnail3,
    },
    {
      name: '④きいろいブロック',
      thumbnail: thumbnail4,
    },
  ],
}

export default mission
